module.exports = __webpack_public_path__ + "static/media/2DGACM7.2b29f9cd.jpg";